import {
  Spacer,
  TitleCell,
  TitleRow
} from '../../../../components/ReusableComponents/Table'

const AutoInviteHealthTitleRow = ({ showTelcoDetails, ...props }) => (
  <>
    {showTelcoDetails ? (
      <TitleRow {...props} style={{ position: 'sticky', top: 70 }}>
        <TitleCell>Id</TitleCell>
        <TitleCell>Hotel name</TitleCell>
        <TitleCell textAlign="center">Click</TitleCell>
        <TitleCell textAlign="center">Text</TitleCell>
        <TitleCell textAlign="center">Booking</TitleCell>
        <TitleCell textAlign="center">Converted</TitleCell>

        <TitleCell textAlign="center">Inbound</TitleCell>
        <TitleCell textAlign="center">Outbound</TitleCell>
        <TitleCell textAlign="center">Optout</TitleCell>
        <TitleCell textAlign="center">
          Segment <br /> outbound
        </TitleCell>
        <TitleCell textAlign="center">
          Segment <br /> inbound
        </TitleCell>
        <TitleCell textAlign="center">
          Failed <br /> spam
        </TitleCell>
        <TitleCell textAlign="center">
          Failed <br /> other
        </TitleCell>
        <TitleCell>Notes</TitleCell>
      </TitleRow>
    ) : (
      <TitleRow style={{ position: 'sticky', top: 70 }}>
        <TitleCell>Id</TitleCell>
        <TitleCell>Hotel name</TitleCell>
        <TitleCell textAlign="center">Click</TitleCell>
        <TitleCell textAlign="center">Text</TitleCell>
        <TitleCell textAlign="center">Booking</TitleCell>
        <TitleCell textAlign="center">Converted</TitleCell>
        <Spacer />
        <TitleCell textAlign="center">3 Mo</TitleCell>
        <TitleCell textAlign="center">6 Mo</TitleCell>
        <TitleCell textAlign="center">9 Mo</TitleCell>
        <TitleCell textAlign="center">12 Mo</TitleCell>
        <TitleCell textAlign="center">15 Mo</TitleCell>
        <TitleCell textAlign="center">15 Mo+</TitleCell>
        <TitleCell textAlign="center">
          After
          <br /> visit
        </TitleCell>
        <TitleCell>Notes</TitleCell>
      </TitleRow>
    )}
  </>
)

export default AutoInviteHealthTitleRow
